
const criteria = {

    namespaced: true,
    state: {
        type:null
    },


    getters: {
        getCriteria:state=>state
    },

    actions: {
      actionSetType({commit},type){
        commit('setType',type);
      }
    },
    // mutations
    mutations: {
        setType(state,type){
            state.type = type;
        }
    }
}



export default criteria